document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.shopify-custom-article');
  if (!container) return;

  const questions = container.querySelectorAll('.faq-question');

  questions.forEach((question) => {
    question.addEventListener('click', function () {
      const answer = this.nextElementSibling;
      const isOpen = this.classList.contains('active');

      // Luk alle først
      container.querySelectorAll('.faq-question').forEach((q) => q.classList.remove('active'));
      container.querySelectorAll('.faq-answer').forEach((a) => a.classList.remove('active'));

      // Hvis den ikke var åben, så åbn den
      if (!isOpen) {
        this.classList.add('active');
        if (answer) {
          answer.classList.add('active');
        }
      }
    });
  });
});
